import { Access } from "../../../../access/types.ts";
import {
  routingRuleIdParameter,
  routingRuleNameParameter,
  sudoParameter,
} from "./parameters.ts";

export const commonAllAccess = Access({
  description: "All resources",
  label: "SSH All",
  maturity: "ga",
  delegation: {},
  generated: {},
  parameters: {
    sudo: sudoParameter,
    routingRuleId: routingRuleIdParameter,
    routingRuleName: routingRuleNameParameter,
  },
  render: { locator: "routingRuleName", policy: "sudo" } as const,
});
